export default "__VITE_ASSET__4a90f371__"